import React from 'react';
import classNames from 'classnames';
import 'assets/styles/components/Container.less';

export default function Container({children, className, ...rest}) {
  return (
    <div className={classNames('container', className)} {...rest}>
      {children}
    </div>
  )
}